import { DonatedDoc, Document } from "../../types";

export const handleDownloadDocument = async (id: string, downloadData: Document | DonatedDoc, downloadFileName: string) => {
    if (id && downloadData?.fullUrl) {
        const fileUrl = downloadData?.fullUrl;
        try {
            const response = await fetch(fileUrl);
            if (!response.ok) {
                throw new Error("Network response was not ok");
            }
            const blob = await response.blob();
            const link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = downloadFileName || `${id}.pdf`;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        } catch (error) {
            console.error("Error downloading the PDF:", error);
        }
    }
};

export const findLatestDocument = (documents: Document[]) => {
    return documents.reduce((latest, doc) =>
        new Date(doc?.updatedAt ?? doc?.createdAt) > new Date(latest?.updatedAt ?? latest?.createdAt) ? doc : latest
        , documents[0]);
};
